function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
var SegmentAnalytics = /*#__PURE__*/function () {
  function SegmentAnalytics(_ref) {
    _classCallCheck(this, SegmentAnalytics);
    var analytics = _ref.analytics,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 3000 : _ref$timeout;
    this.analytics = analytics;
    this.timeout = timeout;
  }
  _createClass(SegmentAnalytics, [{
    key: "reportSignUp",
    value: function reportSignUp(_ref2) {
      var _this = this;
      var analyticsProperties = _ref2.analyticsProperties,
        member = _ref2.member;
      var memberProperties = analyticsProperties.memberProperties,
        accountCreateProperties = analyticsProperties.accountCreateProperties;
      var trackEventData = _objectSpread(_objectSpread({
        platform: 'web'
      }, accountCreateProperties), {}, {
        tkwwEntities: {
          member: member
        }
      });
      return new _Promise(function (resolve, reject) {
        _setTimeout(reject, _this.timeout, new Error('Segment timed out.'));
        _this.analytics.alias(memberProperties.userId, memberProperties, function () {
          var identifyData = _objectSpread(_objectSpread({}, memberProperties), {}, {
            unreadMessages: 0
          });
          _this.analytics.identify(memberProperties.userId, identifyData, function () {
            _this.analytics.track('New Registration', trackEventData, resolve);
          });
        });
      });
    }
  }, {
    key: "reportLogIn",
    value: function reportLogIn(_ref3) {
      var _this2 = this;
      var analyticsProperties = _ref3.analyticsProperties,
        member = _ref3.member;
      var memberProperties = analyticsProperties.memberProperties,
        accountCreateProperties = analyticsProperties.accountCreateProperties;
      var trackEventData = _objectSpread(_objectSpread({
        platform: 'web'
      }, accountCreateProperties), {}, {
        tkwwEntities: {
          member: member
        }
      });
      return new _Promise(function (resolve, reject) {
        _setTimeout(reject, _this2.timeout, new Error('Segment timed out.'));
        _this2.analytics.identify(memberProperties.userId, memberProperties, function () {
          _this2.analytics.track('Log In', trackEventData, resolve);
        });
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      return this.analytics.reset();
    }
  }]);
  return SegmentAnalytics;
}();
export { SegmentAnalytics as default };